import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    OnInit,
    Renderer2,
    ViewChild,
    ViewContainerRef
} from "@angular/core";
import {NavigationService} from "../../navigation.service";
import {Direction} from "../../../common-types/direction";
import {ComparablePageGeometry, PageAlignment, PageComponentContainer, PageGeometry, PageSpec} from "../../page";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {ResponsiveService} from "../../responsive.service";

@Component({
    selector: "woa-page-component-container",
    templateUrl: "./page-component-container.component.html"
})
export class PageComponentContainerComponent implements PageComponentContainer, OnInit, AfterContentInit {
    PageAlignment = PageAlignment;
    Direction = Direction;

    @ViewChild("content", {read: ViewContainerRef}) viewContainerRef: ViewContainerRef;

    public geometry$?: Subject<PageGeometry> = new Subject<PageGeometry>();

    open$: Subject<boolean> = new BehaviorSubject<boolean>(false);

    initialised: boolean = false;

    geometry: PageGeometry;

    private openPending: boolean = false;

    private subscriptions: Subscription = new Subscription();

    constructor(public pageSpec: PageSpec,
                public responsiveService: ResponsiveService,
                private navigationService: NavigationService,
                private renderer: Renderer2,
                private changeDetectorRef: ChangeDetectorRef) {
        this.geometry = new PageGeometry();
        this.subscriptions.add(this.geometry$.subscribe((geometry: PageGeometry) => {
            const newGeometry: ComparablePageGeometry = Object.assign(Object.assign(new ComparablePageGeometry(), this.pageSpec.geometry), geometry || {});
            if (!newGeometry.equals(this.geometry)) {
                this.geometry = newGeometry;
                this.changeDetectorRef.detectChanges();
            }
        }));
    }

    get swipeDirection(): Direction {
        return this.geometry.disableSwipe ? Direction.NONE
            : this.geometry.alignment === PageAlignment.LEFT ? Direction.LEFT
                : this.geometry.alignment === PageAlignment.RIGHT ? Direction.RIGHT
                    : this.geometry.alignment === PageAlignment.TOP ? Direction.UP
                        : this.geometry.alignment === PageAlignment.BOTTOM ? Direction.DOWN
                            : Direction.NONE;
    }

    ngOnInit(): void {
        this.renderer.addClass(this.pageSpec.componentRef.location.nativeElement, "page-component");
        this.pageSpec.componentRef.changeDetectorRef.detectChanges();
        this.viewContainerRef.insert(this.pageSpec.componentRef.hostView);
    }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.initialised = true;
            if (this.openPending) {
                this.openPageComponent();
            }
        }, 250);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    @HostListener("click", ["$event"])
    dismissPage(event?: MouseEvent): void {
        if (event) {
            event.stopPropagation();
        }

        // noinspection JSIgnoredPromiseFromCall
        this.navigationService.dismissPage(this.pageSpec.componentRef.instance);
    }

    ignore(event: MouseEvent): void {
        event.stopPropagation();
    }

    public openPageComponent(): void {
        if (!this.initialised) {
            this.openPending = true;
            return;
        }
        this.openPending = false;
        this.open$.next(true);
        this.changeDetectorRef.detectChanges();
    }

    public closePageComponent(): void {
        this.open$.next(false);
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/orchestration/page-container/page-component-container/page-component-container.component.ts